// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-sub-heading----styles-module---container---5n8Nc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/sub-heading/styles.module.css
// module id = 637
// module chunks = 168707334958949